<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    movie_edit
                </mat-icon>
                <span>
                    Production: {{ this.itemEnvelope?.ItemId }}: {{ this.itemEnvelope?.ItemName }}
                </span>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                {{ subtitle }}
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <form>
                <div class="flex-direction-horizontal">
                    <div class="flex-container-basic">
                        <app-image srcPath="{{ this.itemEnvelope?.Document?.Item?.AvatarBlobPath == null ? appService.defaultImageUri : this.itemEnvelope?.Document?.Item?.AvatarBlobPath }}" isApiImage="{{ this.itemEnvelope?.Document?.Item?.AvatarBlobPath == null ? 'false' : 'true' }}" className="app-image-medium app-image-circle"></app-image>
                    </div>
                    <div class="flex-direction-vertical flex-container-basic">
                        <mat-form-field appearance="outline">
                            <mat-label>Name</mat-label>
                            <input *ngIf="itemEnvelope" matInput name="Name" placeholder="First Name" [(ngModel)]="itemEnvelope.Document.Item.Name" />
                        </mat-form-field>
                        <br />
                        <mat-form-field appearance="outline">
                            <mat-label>Status</mat-label>
                            <mat-select name="ProductionStatuses" [(ngModel)]="this.itemEnvelope?.Document?.Item.ProductionStatusId">
                                <mat-option *ngFor="let productionStatus of this.productionStatuses" [value]="productionStatus.ProductionStatusId">{{ productionStatus.UID }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </form>
            <mat-tab-group (selectedTabChange)="onTabChange($event)">
                <br />
                <mat-tab label="General">
                    <br />
                    <form>
                        <span class="{{ dynamicClassNameRoleSpan }}">
                            <mat-form-field appearance="outline">
                                <mat-label>Role</mat-label>
                                <input matInput name="RoleName" placeholder="Role Name" [(ngModel)]="enteredRoleName" />
                            </mat-form-field>
                            &nbsp;
                            &nbsp;
                            <mat-form-field appearance="outline">
                                <mat-label>Description</mat-label>
                                <input matInput name="RoleDescription" placeholder="Brief Description" [(ngModel)]="enteredRoleDescription" />
                            </mat-form-field>
                        </span>
                        &nbsp;
                        &nbsp;
                        <button mat-button (click)="addRoleToProduction()" [disabled]="dynamicClassNameRoleSpan == 'expanding-span-expanded' && this.enteredRoleName.trim() == ''">
                            <mat-icon class="material-symbols-outlined" matTooltip="{{ dynamicClassNameRoleSpan == 'expanding-span-expanded' && this.enteredRoleName.trim() == '' ? 'Enter at least a role name to enable this button (description is optional)' : '' }}">
                                {{ dynamicClassNameRoleSpan == 'expanding-span-expanded' && this.enteredRoleName.trim() == '' ? 'warning' : 'add' }}
                            </mat-icon>
                            ADD ROLE
                        </button>
                        <button mat-button *ngIf="dynamicClassNameRoleSpan == 'expanding-span-expanded'" (click)="cancelAddRoleToProduction()">
                            <mat-icon class="material-symbols-outlined">
                                cancel
                            </mat-icon>
                            CANCEL
                        </button>
                        <br />
                        <table mat-table *ngIf="itemEnvelope" [dataSource]="productionRolesDatasource" class="mat-elevation-z8" matSort>
                            <ng-container matColumnDef="RoleName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Role</th>
                                <td mat-cell *matCellDef="let productionRole">{{ productionRole.Name }}</td>
                            </ng-container>
                            <ng-container matColumnDef="RoleDescription">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
                                <td mat-cell *matCellDef="let productionRole">{{ productionRole.Description }}</td>
                            </ng-container>
                            <ng-container matColumnDef="Delete">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                                <td mat-cell *matCellDef="let productionRole">
                                    <mat-icon class="material-symbols-outlined" (click)="deleteProductionRole(productionRole)">
                                        delete
                                    </mat-icon>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedProductionRoleColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedProductionRoleColumns"></tr>
                        </table>
                    </form>
                </mat-tab>
                <mat-tab label="Staff and Crew">
                    <br />
                    <form>
                        <span class="{{ dynamicClassNameStaffSpan }}">
                            <app-chip-selector #resourceChipSelector label="Resource" className="width-medium-narrow" [isMultiSelect]="false" [availableItems]="availableResources" [selectedItemIds]="selectedResourceIds"></app-chip-selector>
                            &nbsp;
                            &nbsp;
                            <mat-form-field appearance="outline">
                                <mat-label>Type</mat-label>
                                <mat-select #resourceTypesSelector name="ResourceTypes" [(ngModel)]="selectedResourceTypeId" (selectionChange)="onResourceTypeChange($event)">
                                    <mat-option *ngFor="let resourceType of resourceTypes" [value]="resourceType.ResourceTypeId">{{ resourceType.UID }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </span>
                        &nbsp;
                        &nbsp;
                        <button mat-button (click)="addResourceToProduction()" [disabled]="dynamicClassNameStaffSpan == 'expanding-span-expanded' && !(selectedResourceIds.length > 0 && selectedResourceTypeId != undefined)">
                            <mat-icon class="material-symbols-outlined" matTooltip="{{ dynamicClassNameStaffSpan == 'expanding-span-expanded' && !(selectedResourceIds.length > 0 && selectedResourceTypeId != undefined) ? 'Select a resource and resource type to enable this button' : '' }}">
                                {{ dynamicClassNameStaffSpan == 'expanding-span-expanded' && !(selectedResourceIds.length > 0 && selectedResourceTypeId != undefined) ? 'warning' : 'add' }}
                            </mat-icon>
                            ADD RESOURCE
                        </button>
                        <button mat-button *ngIf="dynamicClassNameStaffSpan == 'expanding-span-expanded'" (click)="cancelAddResourceToProduction()">
                            <mat-icon class="material-symbols-outlined">
                                cancel
                            </mat-icon>
                            CANCEL
                        </button>
                        <br />
                        <table mat-table *ngIf="itemEnvelope" [dataSource]="productionResourcesDatasource" class="mat-elevation-z8" matSort>
                            <ng-container matColumnDef="Avatar">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                                <td mat-cell *matCellDef="let productionResource">
                                    <app-image srcPath="{{ getAvatarBlobPathFromResourceId(productionResource.ResourceId) }}" isApiImage="true" class="margin-wide-right nudge-down-small" className="app-image-extra-small app-image-circle"></app-image>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="ResourceName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Resource</th>
                                <td mat-cell *matCellDef="let productionResource">{{ getResourceFullNameFromResourceId(productionResource.ResourceId) }}</td>
                            </ng-container>
                            <ng-container matColumnDef="ResourceType">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
                                <td mat-cell *matCellDef="let productionResource">{{ getResourceTypeNameFromProductionTypeId(productionResource.ResourceTypeId) }}</td>
                            </ng-container>
                            <ng-container matColumnDef="Delete">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                                <td mat-cell *matCellDef="let productionResource">
                                    <mat-icon class="material-symbols-outlined" (click)="deleteProductionResource(productionResource)">
                                        delete
                                    </mat-icon>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedProductionResourceColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedProductionResourceColumns"></tr>
                        </table>
                    </form>
                </mat-tab>
                <mat-tab label="Engagements">
                    <br />
                    <button mat-button (click)="addEngagement()">
                        <mat-icon class="material-symbols-outlined">
                            add
                        </mat-icon>
                        ADD NEW ENGAGEMENT
                    </button>
                    <br />
                    <br />
                    <table mat-table *ngIf="itemEnvelope" [dataSource]="engagementsDatasource" class="search-result mat-elevation-z8" matSort>
                        <ng-container matColumnDef="Avatar">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                            <td mat-cell *matCellDef="let engagement" (click)="editEngagement(engagement)">
                                <app-image srcPath="{{ getResourceAvatarBlobPathFromEngagement(engagement) }}" isApiImage="true" (click)="editEngagement(engagement)" class="margin-wide-right nudge-down-small" className="app-image-extra-small app-image-circle"></app-image>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="ResourceName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Client </th>
                            <td mat-cell *matCellDef="let engagement" (click)="editEngagement(engagement)">
                                {{ getResourceNameFromEngagement(engagement) }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="RoleName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
                            <td mat-cell *matCellDef="let engagement" (click)="editEngagement(engagement)">
                                {{ getProductionRoleNameFromEngagement(engagement) }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="EngagementStatus">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                            <td mat-cell *matCellDef="let engagement" (click)="editEngagement(engagement)">
                                {{ getEngagementStatusNameFromEngagement(engagement) }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="StartOnUTC">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Start On </th>
                            <td mat-cell *matCellDef="let engagement" (click)="editEngagement(engagement)">
                                {{ engagement.StartOnUTC }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="Delete">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                            <td mat-cell *matCellDef="let engagement">
                                <button mat-button (click)="deleteEngagement(engagement)">
                                    <mat-icon class="material-symbols-outlined">
                                        delete
                                    </mat-icon>
                                </button>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedEngagementsColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedEngagementsColumns"></tr>
                    </table>
                </mat-tab>
                <mat-tab *ngIf="!isRevisionMode" label="History">
                    <div class="history-container">
                        <div class="history-container-section">
                            <app-history #appHistory *ngIf="this.itemEnvelope" [itemEnvelope]="this.itemEnvelope" [itemService]="this.itemService"></app-history>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>
